export default __webpack_public_path__ + "static/media/autosled_logo.9451716b.png";